import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

import { resolveNavSlotPath } from "~/components/mobile/bottomNav/mobileBottomNav";
import isRecord from "~/helpers/isRecord";
import ENGAGE_NAMESPACES from "~mobile/engage/engageNamespaces";

export const ENGAGE_HISTORY_TARGET_KIND = "engageHistory";

export const ENGAGE_HISTORY_RAIL_ID = "history";

export interface EngageHistoryScope {
	basePath: string;
	locationId: string;
}

export const buildEngageHistoryTarget = (scope: EngageHistoryScope): ContinuationTarget => ({
	targetId: JSON.stringify(scope),
	targetKind: ENGAGE_HISTORY_TARGET_KIND
});

const isEngageNamespace = (value: unknown): value is string =>
	ENGAGE_NAMESPACES.some((namespace) => namespace === value);

const parseTargetId = (targetId: string): unknown => {
	try {
		return JSON.parse(targetId);
	} catch {
		return null;
	}
};

export const readEngageHistoryScope = (target: ContinuationTarget | null | undefined): EngageHistoryScope | null => {
	if (target?.targetKind !== ENGAGE_HISTORY_TARGET_KIND) return null;
	const scope = parseTargetId(target.targetId);
	if (!isRecord(scope) || !isEngageNamespace(scope.basePath)) return null;
	if (typeof scope.locationId !== "string" || scope.locationId === "") return null;
	return { basePath: scope.basePath, locationId: scope.locationId };
};

const engageHistoryReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: (target) => {
		const scope = readEngageHistoryScope(target);
		return scope ? resolveNavSlotPath(scope.basePath, ENGAGE_HISTORY_RAIL_ID) : "";
	},
	matchesRoute: () => null
};

export default engageHistoryReceiverIdentityAdapter;
